import CourseCard from "./CourseCard.vue";
import CardHeader from "@/pages/components/CardHeader";
import Live from "./Live.vue";
import { Empty } from "zhs-components";
import UserCard from './UserCard/index';
export default {
  components: {
    CourseCard,
    Live,
    Empty,
    CardHeader,
    UserCard
  },
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    }
  },

  created() {
    this.getAuth();
    this.getTypeList();
  },

  watch: {
    typeId(val) {
      if (val) {
        this.getHomeCourseList();
      }
    }

  },

  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      abbr: this.$config.abbr,
      classId: undefined,
      authType: 0,
      typeList: [],
      hiddenMoreClass: true,
      typeId: ""
    };
  },

  methods: {
    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeMooc({
        num: this.menu.num,
        menu_id: this.menu.id,
        classify_id: this.typeId
      });
      console.log(homeCourse);
      this.homeCourseList = homeCourse;
    },

    async getAuth() {
      const res2 = await this.$http.getConfigList();
      this.authType = res2.find(item => item.code == "10401") ? res2.find(item => item.code == "10401").auth_type : 0;
    },

    async getTypeList() {
      const res = await this.$http.getCourseType({
        menu_id: this.menu.id
      });
      console.log(this.typeList, '========>>>>>>>');
      this.typeList = res;

      if (res && res.length) {
        this.typeId = res[0].id;
      }
    },

    searchCourseList(id) {
      this.typeId = id;
    }

  }
};